export const resolveAccompanimentQuota = (product, variation = null) =>
  Math.max(
    0,
    Number(
      variation?.free_accompaniment_quota ??
        product?.free_accompaniment_quota ??
        1,
    ) || 0,
  );

export const countSelectedAccompaniments = (extras = []) =>
  (Array.isArray(extras) ? extras : [])
    .filter((extra) => extra?.type === "accompaniment")
    .reduce(
      (sum, extra) => sum + Math.max(1, Number(extra.selectedQuantity) || 1),
      0,
    );

export const getSelectableExtraMaximum = ({ extra, selectedExtras, quota }) => {
  const configuredMaximum = Math.max(1, Number(extra?.max_quantity) || 1);
  if (extra?.type !== "accompaniment") return configuredMaximum;
  const others = (Array.isArray(selectedExtras) ? selectedExtras : [])
    .filter(
      (selected) =>
        selected?.type === "accompaniment" && selected?.id !== extra?.id,
    )
    .reduce(
      (sum, selected) =>
        sum + Math.max(1, Number(selected.selectedQuantity) || 1),
      0,
    );
  return Math.max(0, Math.min(configuredMaximum, Number(quota) - others));
};

export const getLineAccompanimentCapacity = ({
  product,
  variation,
  quantity,
}) =>
  resolveAccompanimentQuota(product, variation) *
  Math.max(0, Number(quantity) || 0);
